<ng-container [ngSwitch]="sliderType">
    <div *ngSwitchCase="'row'">
        <kw-row-slider [data]="data" [edit]="edit"></kw-row-slider>
    </div>
    <div *ngSwitchCase="'tabbed'">
        <kw-tabbed-slider [data]="data" [edit]="edit"></kw-tabbed-slider>
    </div>
    <div *ngSwitchCase="'show'">
        <kw-show-slider [data]="data" [edit]="edit"></kw-show-slider>
    </div>
    <div *ngSwitchCase="'eye'">
        <kw-eye-slider [data]="data" [edit]="edit"></kw-eye-slider>
    </div>
    <div *ngSwitchDefault>
        <!-- <kw-tabbed-slider></kw-tabbed-slider> -->
        <kw-row-slider [data]="data" [edit]="edit"></kw-row-slider>
    </div>
</ng-container>
<!-- <div 
    [@sliderAnimation]="selectedIndex"
    slideControl
    [itemsLength]="itemsLength"
    [autoStart]="autoStart"
    #ctrl="slideControl"
    (selectedIndex)="selectedIndex = $event"
    (actualIndex)="actualIndex = $event"
    class="slider-container">
    <div class="slider-items" *ngFor="let slide of items">
        <div class="slide-item" *ngFor="let item of slide">
            <div>
                <img src="{{item?.imgSrc}}"/>
            </div>
            <div>
                {{item?.text}}
            </div>
        </div>
    </div>
    <div  
        class="ctrl-next-container" 
        (click)="ctrl.next()"
        [ngClass]="actualIndex == 0 ? 'hide-ctrl': 'display-ctrl'">
        <i class="fa fa-angle-left"></i>
    </div>
    <div
        class="crtl-prev-container" 
        [ngClass]="actualIndex < itemsLength-1 ? 'display-ctrl': 'hide-ctrl'"
        (click)="ctrl.previous()">
        <i class="fa fa-angle-right"></i>
    </div>
</div> -->

